<template>
  <div class="tour-edit">
    <transition name="slide" mode="out-in">
      <div v-if="confirmRemove" key="remove" class="remove">
        <div class="title">Are you sure you want to remove this tour?</div>
        <div class="sub-text">Once removed, the tour will no longer be active and will not be visible on your dashboard.</div>
        <button type="button" class="btn btn-red-outline" v-on:click="remove" :disabled="isLoadingRemove">
          <span class="spinner-border spinner-border-sm" role="status" v-if="isLoadingRemove"></span>
          <span v-else>Yes, remove tour.</span>
        </button>
        <div class="form-group error" v-if="error">
          {{ error }}
        </div>
      </div>
      <div v-else key="form">
        <transition name="slide" mode="out-in">
          <div class="title" v-if="!tour" key="create">
            Schedule a Tour
          </div>
          <div class="title" v-else key="edit">
            <button class="btn" v-on:click="cancel">
              <img src="../assets/icons/back.svg" alt="Back" />
            </button>
            Tour Details
          </div>
        </transition>
        <form class="form" v-on:submit.prevent="save" autocomplete="off">
          <div class="form-group row">
            <label for="fullName" class="col-form-label col-md-3">Client:</label>
            <div class="col-md-9">
              <input type="text" name="fullName" id="fullName" placeholder="Enter full name" class="form-control" v-model="fullName" :readonly="tour" />
            </div>
          </div>
          <div class="form-group row">
            <label for="tourMonth" class="col-form-label col-md-3">Tour date:</label>
            <div class="col-md-9">
              <div class="row less-gap">
                <div class="col-md-12 col-lg-4 mt-md-2 mt-lg-0">
                  <select name="tourMonth" id="tourMonth" class="form-control" v-model="tourMonth">
                    <option value="">Month</option>
                    <option v-for="month in months" :value="month" :key="month">{{ month }}</option>
                  </select>
                </div>
                <div class="col-md-12 col-lg-4 mt-md-2 mt-lg-0">
                  <select name="tourDay" id="tourDay" class="form-control" v-model="tourDay">
                    <option value="">Day</option>
                    <option v-for="day in 31" :value="day" :key="day">{{ day }}</option>
                  </select>
                </div>
                <div class="col-md-12 col-lg-4 mt-md-2 mt-lg-0">
                  <select name="tourYear" id="tourYear" class="form-control" v-model="tourYear">
                    <option value="">Year</option>
                    <option v-for="year in years" :value="year" :key="year">{{ year }}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <label for="tourTime" class="col-form-label col-md-3">Timeslot:</label>
            <div class="col-md-9">
              <select name="tourTime" id="tourTime" class="form-control" v-model="timeslot">
                <option value="">Select timeslot</option>
                <option v-for="timeslot in timeslots" :value="timeslot" :key="timeslot">{{ timeslot }}</option>
              </select>
            </div>
          </div>
          <div class="form-group row">
            <label for="email" class="col-form-label col-md-3">Email:</label>
            <div class="col-md-9">
              <input type="email" name="email" id="email" placeholder="Enter email" class="form-control" v-model="email" :readonly="tour" />
            </div>
          </div>
          <div class="form-group row">
            <label for="phone" class="col-form-label col-md-3">Phone:</label>
            <div class="col-md-9">
              <input type="tel" name="phone" id="phone" placeholder="Enter phone number" class="form-control" v-model="phone" :readonly="tour" />
            </div>
          </div>
          <div class="form-group row">
            <label for="notes" class="col-form-label col-md-3">Notes:</label>
          </div>
          <div class="form-group row">
            <div class="col">
              <textarea name="notes" id="notes" placeholder="Enter your notes" class="form-control" rows="4" v-model="notes" v-on:change="limitNotes" />
              <span class="count">{{ notes.length }} / {{ maxNotesChars }} Characters</span>
            </div>
          </div>
          <div class="form-group error" v-if="error">
            <p>{{ error }}</p>
          </div>
          <div class="form-group">
            <div class="row">
              <div v-if="tour" class="col">
                <button type="button" class="btn btn-red-outline btn-block" v-on:click="showRemoveConfirm">
                  <span>Remove</span>
                </button>
              </div>
              <div class="col">
                <button type="submit" class="btn btn-red btn-block">
                  <span class="spinner-border spinner-border-sm" role="status" v-if="isLoading"></span>
                  <span v-else-if="tour">Update</span>
                  <span v-else>Schedule</span>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </transition>
  </div>
</template>

<script>
import moment from "moment";
import axios from "axios";

export default {
  name: "EditTour",
  data: function () {
    return {
      months: moment.months(),
      years: [
        moment().year(),
        moment().add(1, 'years').year(),
      ],
      fullName: "",
      tourMonth: "",
      tourDay: "",
      tourYear: "",
      timeslot: "",
      email: "",
      phone: "",
      notes: "",
      maxNotesChars: 200,
      isLoading: false,
      isLoadingRemove: false,
      error: "",
      confirmRemove: false,
      timeslots: [
        '9:00 am',
        '9:30 am',
        '10:00 am',
        '10:30 am',
        '11:00 am',
        '11:30 am',
        '3:00 pm',
        '3:30 pm',
        '4:00 pm',
        '4:30 pm',
      ]
    };
  },
  props: [ 'tour', 'notify', 'cancel' ],
  watch: {
    tour: function(newVal) {
      if (newVal != null) {
        this.fullName = this.tour.name;
        this.notes = this.tour.message;
        let tourTimeslot = new Date(this.tour.timeSlot);
        this.tourMonth = tourTimeslot.toLocaleString('en-US', { month: 'long' });
        this.tourDay = tourTimeslot.toLocaleString('en-US', { day: 'numeric' });
        this.tourYear = tourTimeslot.toLocaleString('en-US', { year: 'numeric' });
        this.timeslot = tourTimeslot.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' }).toLowerCase();
        this.email = this.tour.email;
        this.phone = this.tour.phone;
        this.confirmRemove = false;
      }
      else {
        this.fullName = "";
        this.notes = "";
        this.tourMonth = "";
        this.tourDay = "";
        this.tourYear = "";
        this.timeslot = "";
        this.email = "";
        this.phone = "";
        this.confirmRemove = false;
      }
    }
  },
  methods: {
    save: function () {
      this.isLoading = false;
      this.error = "";

      if (!this.fullName || !this.timeslot || !this.tourMonth || !this.tourDay || !this.tourYear || !this.email || !this.notes || !this.phone) {
        this.error = "Please fill in all fields";
        return;
      }

      let reqData = new FormData();
      reqData.append('name', this.fullName);
      reqData.append('message', this.notes);
      reqData.append('email', this.email);
      reqData.append('phone', this.phone);
      reqData.append('slot', moment(`${this.tourYear} ${this.tourMonth} ${this.tourDay} ${this.timeslot}`, 'YYYY MMMM D h:mm a'));

      let reqUrl = "/api/tours/create";
      if (this.tour && this.tour.id) {
        reqUrl = `/api/tours/${this.tour.id}/update`;
      }

      this.isLoading = true;

      axios.post(reqUrl, reqData)
        .then((response) => {
          this.isLoading = false;
          this.fullName = "";
          this.notes = "";
          this.tourYear = "";
          this.tourMonth = "";
          this.tourDay = "";
          this.timeslot = "";
          this.email = "";
          this.phone = "";
          this.notify(response.data.tour, !(this.tour && this.tour.id));
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.response) {
            let errorStr = "";
            if (error.response.data.error) {
              errorStr = error.response.data.error;
            }
            else if (error.response.data.errors) {
              errorStr = error.response.data.errors[Object.keys(error.response.data.errors)[0]][0];
            }
            else {
              errorStr = error.response.data.message;
            }

            this.error = errorStr;
          }
          else {
            this.error = "Sorry, something went wrong. Please try again later."
          }
        });
    },
    limitNotes: function () {
      if (this.notes.length > this.maxNotesChars) {
        this.notes = this.notes.slice(0, this.maxNotesChars);
      }
    },
    showRemoveConfirm: function () {
      this.confirmRemove = true;
    },
    remove: function () {
      this.isLoadingRemove = true;
      axios.get(`/api/tours/${this.tour.id}/delete`)
        .then(() => {
          this.isLoadingRemove = false;
          this.notify(this.tour, false, true);
          this.confirmRemove = false;
        })
        .catch((error) => {
          this.isLoadingRemove = false;
          if (error.response) {
            let errorStr = "";
            if (error.response.data.error) {
              errorStr = error.response.data.error;
            }
            else if (error.response.data.errors) {
              errorStr = error.response.data.errors[Object.keys(error.response.data.errors)[0]][0];
            }
            else {
              errorStr = error.response.data.message;
            }

            this.error = errorStr;
          }
          else {
            this.error = "Sorry, something went wrong. Please try again later."
          }
        });
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/_variables";

div.tour-edit {
  height: 100%;
}

div.title {
  color: #4A4A4A;
  font-weight: 500;
  font-size: 1.25rem;
  line-height: 1.2;
  margin: 51px 0 36px;
  position: relative;

  button {
    position: absolute;
    right: 100%;
    padding: 0 10px;
  }
}

div.less-gap.row {
  margin-left: -5px;
  margin-right: -5px;

  > div {
    padding-left: 5px;
    padding-right: 5px;
  }
}

label.col-form-label[for="endDate"] {
  align-items: flex-start;
  padding-top: 1em;
}

label.check {
  margin-top: 0.75em;
  margin-bottom: 0.75em;

  input[type="checkbox"] {
    display: none;

    &:checked + span {
      background-color: var(--accentColor);

      &:after {
        left: calc(100% - 17px);
      }
    }
  }

  span {
    display: block;
    width: 33px;
    height: 20px;
    background-color: darken(#F4F4F3, 10%);
    border-radius: 10px;
    position: relative;
    cursor: pointer;
    transition: background-color 250ms;

    &:after {
      content: "";
      position: absolute;
      display: block;
      top: 3px;
      left: 3px;
      width: 14px;
      height: 14px;
      border-radius: 50%;
      background-color: white;
      transition: left 250ms;
    }
  }
}

span.count {
  display: block;
  font-size: 0.875rem;
  color: rgba(#4A4A4A, 0.55);
  margin: 1em 0;
}

input[readonly] {
  background-color: transparent;
  border-color: transparent;
}

div.remove {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;

  div.title {
    font-weight: 500;
    text-align: center;
    font-size: 1.25rem;
    line-height: calc(24 / 20);
    margin: 0 auto 24px;
    max-width: 213px;
  }

  div.sub-text {
    font-size: 0.875rem;
    text-align: center;
    margin: 0 auto 24px;
    max-width: 310px;
  }
}

.slide-enter-active, .slide-leave-active {
  transition: transform 250ms, opacity 250ms;
}
.slide-enter, .slide-leave-to /* .slide-leave-active below version 2.1.8 */ {
  transform: translateY(25px);
  opacity: 0;
}
</style>
